import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'store/index';

const getCurrentPreviewMask = createSelector(
  (state: Store) => state.search.previewMasks.previewMask,
  (state) => (state.length ? state[0] : undefined),
);

export default getCurrentPreviewMask;
